import { Box, PlacementWithLogical, Tooltip, useBreakpointValue } from '@chakra-ui/react';
import { useDebouncedCallback } from 'hooks/useDebounce';
import { INTERACTION_TRIGGERED, Mixpanel } from 'libs/third-party/Mixpanel';
import { ReactNode } from 'react';
import { TooltipInteraction } from 'types/interactiveWidget.types';

interface TooltipInteractionWrapperProps {
  children: ReactNode;
  interaction?: TooltipInteraction | null;
}

const TooltipInteractionContainer = ({ children, interaction }: TooltipInteractionWrapperProps) => {
  const placement = useBreakpointValue<PlacementWithLogical | undefined>({
    base: 'top',
    md: 'top',
    fallback: 'auto-start',
  });
  const label = interaction?.data?.content || '';
  const customProps = interaction?.data?.elementProps || {};

  const onOpen = () => {
    Mixpanel.track(INTERACTION_TRIGGERED, {
      interaction_type: INTERACTION_TRIGGERED.interactionType.Label,
    });
  };

  // Hover could easily trigger multiple times depending on mouse movement, so debounce the onOpen function
  const debouncedOpen = useDebouncedCallback(onOpen, 300);

  return (
    <Tooltip label={label} hasArrow aria-label='tooltip' placement={placement} onOpen={debouncedOpen} {...customProps}>
      <Box pointerEvents='auto' w='full' h='full'>
        {children}
      </Box>
    </Tooltip>
  );
};

export const TooltipInteractionWrapper = ({ children, interaction }: TooltipInteractionWrapperProps) => {
  if (!interaction?.data?.content) return <>{children}</>;

  return <TooltipInteractionContainer interaction={interaction}>{children}</TooltipInteractionContainer>;
};
